import { useEffect } from "react";
import { MassActionPollingProps, PollingData } from "./types";
import { POLLING_SESSION_STORAGE_KEY } from "./constants";
import { requestFile } from "./requestFile";

export const MassActionPolling = ({ children }: MassActionPollingProps) => {
  useEffect(() => {
    let timerId: ReturnType<typeof setInterval> | null = null;

    const clearTimer = () => {
      if (timerId) {
        clearInterval(timerId);
        timerId = null;
      }
    };

    const massActionPolling = sessionStorage.getItem(
      POLLING_SESSION_STORAGE_KEY
    );

    if (massActionPolling) {
      const {
        action,
        maxCountIntervalRequests,
        requestId,
        intervalTimeout,
      }: PollingData = JSON.parse(massActionPolling);

      if (requestId) {
        const isMassPrintAction = action === "print";

        let requestsCounter = 0;

        timerId = setInterval(() => {
          requestFile({
            isMassPrintAction,
            requestId,
            clearTimer,
          });

          if (maxCountIntervalRequests) {
            requestsCounter++;
            if (requestsCounter === maxCountIntervalRequests) {
              clearTimer();
              sessionStorage.removeItem(POLLING_SESSION_STORAGE_KEY);
            }
          }
        }, intervalTimeout);
      }
    }
  }, []);

  return children;
};
